import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { Dropdown } from 'semantic-ui-react'
import i18n from '~/components/i18n'
import Layout from '~/components/Layout'
import TableComponent from '~/components/TableComponent'
import { FarmersQuery } from '~/QueryHooks/Farmers'
import { SwissQuery } from '~/QueryHooks/SwissQuery'

const getDefaultTableComunHeaders = () => [
  {
    name: i18n.t('Sampling time'),
    key: 'date',
    type: 'date',
    format: 'DD.MM.YYYY'
  },
  {
    name: i18n.t('Fat (in %)'),
    key: 'fat',
    type: 'no-unit-number'
  },
  {
    name: i18n.t('Protein (in %)'),
    key: 'protein',
    type: 'no-unit-number'
  },
  {
    name: i18n.t('Germ count (1000/ml)'),
    key: 'germCount',
    type: 'no-unit-number',
    decimalScale: 0
  },
  {
    name: i18n.t('Cell count (1000/ml)'),
    key: 'cellCount',
    type: 'no-unit-number',
    decimalScale: 0
  },
  {
    name: i18n.t('Inhibitor'),
    key: 'inhibitor'
  },
  {
    name: i18n.t('Urea (mg/dl)'),
    key: 'urea',
    type: 'no-unit-number'
  },
  {
    name: i18n.t('Freezing point (in °C)'),
    key: 'freezingPoint',
    type: 'no-unit-number'
  }
]

const SwissMilkSamples: React.FC = () => {
  const { t } = useTranslation()
  const { id } = useParams()

  const [tableColumnHeaders, setTableColumnHeaders] = useState(getDefaultTableComunHeaders())
  const [dataFiltered, setDataFiltered] = useState({
    rows: 10,
    page: 0,
    date: ''
  })

  const {
    data: milkSamples,
    isLoading: isLoadingSamples,
    isFetching: isFetchingSamples,
    refetch: fetchSamples
  } = SwissQuery.getSwissMilkSamples(
    id,
    {
      ...dataFiltered,
      page: dataFiltered.page === 0 ? dataFiltered.page : dataFiltered.page - 1
    },
  )

  const {
    data: milkSampData,
    isLoading: isLoadingSamData
  } = FarmersQuery.getMilkSamplesData(id, dataFiltered)

  useEffect(() => {
    fetchSamples()
  }, [dataFiltered])

  useEffect(() => {
    setTableColumnHeaders(getDefaultTableComunHeaders())
  }, [])

  useEffect(() => {
    if (milkSampData && !dataFiltered.date) {
      setDataFiltered({
        ...dataFiltered,
        date: milkSampData?.months[0]?.key
      })
    }
  }, [milkSampData])

  function renderTable() {
    return <TableComponent
      isFetchingData={isFetchingSamples}
      animated
      tableColumnHeaders={tableColumnHeaders}
      dataFiltered={dataFiltered}
      handleChangeDataFiltered={(data, tableColumnHeaders) => {
        setTableColumnHeaders(tableColumnHeaders)
        setDataFiltered(data)
      }}
      rows={rows}
      total={filtered}
    />
  }

  function renderDataFilter() {
    return <Dropdown
      placeholder={t('Procurement month')}
      options={milkSampData?.months?.map(month => ({ value: month.key, text: month.label })) || []}
      selectOnBlur={false}
      style={{ marginBottom: '1em' }}
      value={dataFiltered.date}
      selection
      onChange={(_, data) => setDataFiltered({
        ...dataFiltered,
        date: data.value as string
      })}
    />
  }

  const { filtered, rows } = milkSamples ? milkSamples : { filtered: 0, rows: [] };

  return <Layout
    title={''}
    childContainerSize={'450px'}
    filters={renderDataFilter()}
    fontSizeHeader={'18px'}
    useSpinner
    isBusy={isLoadingSamples || isLoadingSamData}
  >
    {renderTable()}
  </Layout>
}
export default SwissMilkSamples